import React from "react";
import { useField } from "formik";
import Select, { SelectProps } from "../Select/Select";
import { ISelectOption } from "../../commonTypes";

interface Props extends Omit<SelectProps, "value"> {
  name: string;
}

const FormSelect = ({ name, options, ...props }: Props) => {
  const [field, , helpers] = useField(name);

  const onChange = async (updatedValue?: ISelectOption | ISelectOption[]) => {
    let newValue;

    if (!updatedValue) {
      newValue = undefined;
    } else if (Array.isArray(updatedValue)) {
      newValue = updatedValue.map((option: ISelectOption) => option.value);
    } else {
      newValue = updatedValue.value;
    }

    await helpers.setValue(newValue);
    helpers.setTouched(true, true);
  };

  return (
    <Select
      name={name}
      options={options}
      value={field.value}
      onChange={onChange}
      onBlur={() => helpers.setTouched(true, true)}
      {...props}
    />
  );
};

export default FormSelect;
